// extracted by mini-css-extract-plugin
export default {"logo":"x2w504","link":"Tz56Eh"};